import styled from 'styled-components';
import Markdown from 'markdown-to-jsx';
import { Theme } from '../../../../../../theme/theme';
import { Text } from '../../../../../../CommonComponents/OPL/Text/Text';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';

export const DisclosuresWrapper = styled(Box)<{ theme: Theme }>(({ theme }) => ({
  padding: 24,
  border: `1px solid ${theme.colors.neutral['200']}`,
  borderLeftWidth: 0,
  borderRightWidth: 0,
  maxHeight: '50vh',
  overflowY: 'auto',
}));

export const StyledMarkdown = styled(Markdown)<{ theme: Theme }>(({ theme }) => ({
  p: {
    color: theme.colors.neutral['700'],
    fontFamily: theme.fontFamily,
    fontSize: theme.fontSizes.body,
    lineHeight: theme.lineHeights.body,
    marginTop: 0,
    marginBottom: 8,
  },
}));

export const Heading1 = styled(Text)<{ theme: Theme }>(({ theme }) => ({
  fontWeight: 600,
  fontSize: theme.fontSizes.h6,
  lineHeight: theme.lineHeights.h6,
  marginTop: 16,
  marginBottom: 8,
}));

export const Heading2 = styled(Text)<{ theme: Theme }>({
  fontWeight: 600,
  marginTop: 16,
  marginBottom: 8,
});
